import React, { useEffect } from 'react';

import { useSupport } from 'global/SupportContext';

const WhatsappFloatingButton: React.FC = () => {
  const { whatsappNumber, whatsappText, isLoading, error } = useSupport();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (!whatsappNumber) {
      return;
    }

    const body = document.querySelector('body');
    if (body) {
      // Remove all spaces, hyphens and plus signs from the phone number for the URL
      const cleanNumber = whatsappNumber.replace(/[\s+-]/g, '');

      const anchor = document.createElement('a');
      anchor.href = `https://api.whatsapp.com/send?phone=${cleanNumber}${whatsappText ? `&text=${encodeURIComponent(whatsappText)}` : ''}`;
      anchor.className = 'sp-floating-btn';
      anchor.target = '_blank';
      body.appendChild(anchor);
    } else {
      console.warn('[WhatsappFloatingButton] Body element not found');
    }
  }, [whatsappNumber, whatsappText, isLoading]);

  return (
    <style>
      {`
        a.sp-floating-btn {
            position: fixed;
            z-index: 99999 !important;
            bottom: 10px !important;
            right: 10px !important;
            background-image: url('data:image/svg+xml;base64,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');
            display: block;
            width: 50px;
            height: 50px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: 50%;
        }
    `}
    </style>
  );
};

export default WhatsappFloatingButton;
